import React, { Dispatch, SetStateAction } from 'react';
import Modal from '@monofront/design-system/organisms/Modal';
import CreateReviewForm from '@components/CreateReviewForm';
import { useProductLayout } from '@monofront/business/hooks';
import { IProduct } from '@monofront/types';

interface IReviewProductModalProps {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  productSku: string;
  initialRatingSelected: null | number;
  product: IProduct | null;
  onSuccess?: () => void;
}

const ReviewProductModal: React.FC<IReviewProductModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  productSku,
  initialRatingSelected,
  product,
  onSuccess,
}) => {
  const { productLayout: pageContent } = useProductLayout();
  const createReviewParagraph = pageContent.reviews_description;

  return (
    <>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          UNSAFE_className="create-review-modal limited-width-container"
          externalToggle={() => setIsModalOpen(false)}
          hasPadding
        >
          <div className="modal-container">
            <CreateReviewForm
              productSku={productSku}
              createReviewParagraph={createReviewParagraph}
              initialRatingSelected={initialRatingSelected}
              onSuccess={() => {
                setIsModalOpen(false);
                onSuccess?.();
              }}
              product={product}
            />
          </div>
        </Modal>
      )}
      <style jsx>{`
        :global(.create-review-modal) {
          top: 10%;
          width: 70%;
        }

        @media (max-width: 800px) {
          :global(.create-review-modal) {
            top: 5%;
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default ReviewProductModal;
